import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon, BadgeCheck, CheckCircle } from 'lucide-react';
const HeaderGlpAdv1 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-7137">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-7138"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-7139">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-7140">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-7141">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-7142">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-7143">
          <div className="text-left" data-id="element-7144">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-7145">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-7146">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-7147">
        <div className="max-w-4xl mx-auto" data-id="element-7148">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-7149">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-6" data-id="element-7150">
            How To Take Any GLP-1 Drug Without The Nightmares, Anxiety, Or
            Emotional Numbness That Makes You Wonder If It's Worth It
          </h1>

          <div className="my-6" data-id="element-7151">
            <img src="https://cdn.magicpatterns.com/uploads/1rggcG23avR6QSjaCBdvck/Untitled_(1500_x_1000_px)_(1200_x_1000_px)_(1600_x_1200_px)_(3).png" alt="Before and after transformation" className="w-full rounded-lg shadow-md" data-id="element-7152" />
          </div>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-7153">
            A nurse practitioner's discovery—backed by research from Uppsala
            University that saved my sister and is now helping over 36,700
            people lose weight without losing themselves.
          </p>

          {/* Author Byline */}
          <div className="flex items-center gap-3 mb-6 pb-5 border-b border-gray-200" data-id="element-7154">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-gray-200" data-id="element-7155">
              <img src="https://cdn.magicpatterns.com/uploads/4PvNLd6RsPB1kVDZBzePem/c844778a-6484-4fd0-ade7-865535abf330.png" alt="Journalist" className="w-full h-full object-cover" data-id="element-7156" />
            </div>
            <div className="flex-1" data-id="element-7157">
              <div className="flex items-center gap-1 mb-1" data-id="element-7158">
                <span className="text-sm font-medium text-gray-900" data-id="element-7159">
                  Written by Sarah Mitchell
                </span>
                <BadgeCheck className="h-4 w-4 text-blue-600" data-id="element-7160" />
              </div>
              <div className="text-xs text-gray-600 mb-1" data-id="element-7161">
                Investigative Health Journalist • 17 Yrs Exp
              </div>
              <div className="flex items-center gap-3 text-xs text-gray-500" data-id="element-7162">
                <div className="flex items-center gap-1" data-id="element-7163">
                  <ClockIcon className="h-3 w-3" data-id="element-7164" />
                  <span data-id="element-7165">14 min read</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-7166">
                  <EyeIcon className="h-3 w-3" data-id="element-7167" />
                  <span data-id="element-7168">31,542 views</span>
                </div>
              </div>
            </div>
          </div>

          <p className="mb-5 text-base leading-relaxed text-gray-700" data-id="element-7169">
            If you're on Semaglutide or Tirzepatide—and you're noticing things
            like:
          </p>

          <div className="space-y-2 mb-6" data-id="element-7170">
            <div className="flex items-start gap-2" data-id="element-7171">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-7172" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-7173">
                Anxiety that comes from nowhere and won't leave
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-7174">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-7175" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-7176">
                A flat, numb feeling where emotions used to be
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-7177">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-7178" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-7179">
                Vivid nightmares that jolt you awake
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-7180">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-7181" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-7182">
                A sense of dread you can't explain
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-7183">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-7184" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-7185">
                Zero motivation to do things you used to love
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-7186">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-7187" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-7188">
                Feeling disconnected from people close to you
              </p>
            </div>
          </div>

          <p className="mb-5 text-base leading-relaxed text-gray-700" data-id="element-7189">
            ...you're not imagining it. You're not alone.
          </p>

          <p className="mb-5 text-base leading-relaxed text-gray-700" data-id="element-7190">
            And it's not permanent—if you understand{' '}
            <strong data-id="element-7191">
              what's actually happening inside your body right now
            </strong>
            .
          </p>

          <p className="mb-6 text-base leading-relaxed text-gray-700" data-id="element-7192">
            In my 17 years as an investigative health journalist, I've covered
            dozens of pharmaceutical controversies. But this one hit close to
            home.
          </p>
        </div>
      </div>
    </header>;
};
export default HeaderGlpAdv1;